import { Form, Input, message, Space, Image, Button } from "antd";
import ImageFileUpload from "../Inputs/ImageFileUpload";
import { ClientDTO } from "../../backendapi/requests";
import { useCallback, useContext, useEffect, useState } from "react";
import { useClientServiceGetBackendv2Client1, useClientServiceGetBackendv2Client1Key, useClientServicePutBackendv2Client } from "../../backendapi/queries";
import { UploadChangeParam } from "antd/es/upload";
import { ConfigContext } from "../../contexts/ConfigContext";
import { QueryClient } from "@tanstack/react-query";
import { BASE_PATH } from "../../Environment";

const ClientDetailEdit: React.FC<{}> = () => {
  const queryClient = new QueryClient();

  const { currentClient } = useContext(ConfigContext);

  const [form] = Form.useForm<ClientDTO>();
  const [messageApi, contextHolder] = message.useMessage();
  const [clientLogo, setClientLogo] = useState("");

  const { data: clientData } = useClientServiceGetBackendv2Client1(
    {
      key: currentClient.id,
    },
    [useClientServiceGetBackendv2Client1Key, currentClient.id],
    { refetchOnWindowFocus: false }
  );

  const { mutate, isSuccess, isPending, isError, error } = useClientServicePutBackendv2Client();

  const getThumbnailPath = useCallback(() => {
    return `${BASE_PATH}/backendv2/client/${currentClient?.id}/logo?rnd=` + Math.floor(Math.random() * 999999999);
  }, [currentClient?.id]);

  const onSubmit = () => {
    form.submit();
  };

  useEffect(() => {
    if (isSuccess) {
      messageApi.success("Client updated");
      queryClient.invalidateQueries({ queryKey: [useClientServiceGetBackendv2Client1Key] });
    }
  }, [isSuccess, messageApi]);

  useEffect(() => {
    if (isError) {
      messageApi.error(error?.toString());
    }
  }, [error, isError, isSuccess, messageApi]);

  useEffect(() => {
    if (clientData) {
      setClientLogo(getThumbnailPath());
      form.setFieldsValue(clientData as ClientDTO);
    }
  }, [clientData, form]);

  const onFinish = () => {
    if (currentClient) {
      const values = form.getFieldsValue(true) as ClientDTO;

      const updatedClientData: ClientDTO = {
        ...currentClient,
        ...values,
      };

      mutate({ key: currentClient.id, requestBody: updatedClientData });
    }
  };

  const onUpload = (info: UploadChangeParam) => {
    if (currentClient?.id) {
      setClientLogo(getThumbnailPath());
    }
  };

  return (
    <>
      {contextHolder}

      <Form name="basic" form={form} layout="vertical" onFinish={onFinish} style={{ display: "grid", gap: "1rem", gridTemplateColumns: "1fr 1fr" }}>
        <Form.Item rules={[{ required: true }]} name="name" label="Name">
          <Input />
        </Form.Item>

        <Form.Item name="maxModelsPath" label="Max Models Path">
          <Input />
        </Form.Item>

        <Form.Item name="maxModifiersPath" label="Max Modifiers Path">
          <Input />
        </Form.Item>

        <Form.Item name="maxMaterialsPath" label="Max Materials Path">
          <Input />
        </Form.Item>

        <Form.Item name="maxScenesPath" label="Max Scenes Path">
          <Input />
        </Form.Item>

        <Form.Item name="maxOutputPath" label="Max Output Path">
          <Input />
        </Form.Item>

        <Form.Item name="arModelsPath" label="AR Models Path">
          <Input />
        </Form.Item>

        <Form.Item name="arMaterialsPath" label="AR Materials Path">
          <Input />
        </Form.Item>

        <Form.Item label="Thumbnail">
          <Space orientation="vertical">
            <ImageFileUpload title="Upload logo" action={`${BASE_PATH}/backend/clients/${currentClient?.id}/logo`} onUpload={onUpload} />
            <Image placeholder="" preview={false} width={300} src={clientLogo} />
          </Space>
        </Form.Item>
      </Form>
      <div style={{display: "flex", justifyContent: "flex-end"}}>
      <Button onClick={onSubmit} style={{ justifyContent: "flex-end" }} type="primary" loading={isPending}>
        Submit
      </Button>
      </div>
    </>
  );
};

export default ClientDetailEdit;
